// FieldPriority Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TASK_PRIORITIES } from '../../../../shared/constants'
class FieldPriority extends Component {
  static get propTypes () {
    return {
      size: PropTypes.oneOf(['normal', 'small']),
      active: PropTypes.string,
      showOnlyActive: PropTypes.bool,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      size: 'normal',
      active: '',
      showOnlyActive: false,
      onChange: null
    }
  }

  render () {
    const { size, active, showOnlyActive, onChange } = this.props
    const items = Object.values(TASK_PRIORITIES).reverse()

    return (
      <div
        className={`field field-priority field-priority_${size}${
          showOnlyActive ? ' showonlyactive' : ''
        }`}
      >
        {items.map((item) => (
          <span
            className={`priority priority-${item.toLowerCase()}${
              item === active ? ' active' : ''
            }`}
            title={item}
            key={item}
            onClick={(ev) => (onChange ? onChange(item, ev) : null)}
          />
        ))}
      </div>
    )
  }
}

export default FieldPriority
